import { ICreditTransactionTableItem } from "fieldpro-tools";

import TLang from "model/application/Lang";
import { IListSchema } from "model/entities/List";
import { IAction } from "redux/store/model";

import * as types from "./actionTypes";
import { TFetchCustomerAttributeServerResponseData } from "./api";
import { ICustomersState } from "./initialState";
import { ICustomerLegendFE } from "./types";

export interface IChangeSubcategorySuccessActionCreator extends IAction {
  subcategory: any;
}
export interface ISetCustomersLegendActionCreator extends IAction {
  legend: ICustomerLegendFE;
  lang: TLang;
  legendFilterKey: string;
}
export interface IClearLegendsCacheActionCreator extends IAction {}
export interface ISetCustomerLocationsActionCreator extends IAction {
  customerLocations: ICustomersState["customerLocations"];
}

export interface ISetCustomerAttributeActionCreator extends IAction {
  attributeData: Array<TFetchCustomerAttributeServerResponseData>;
  attributeTag: string;
}

export interface IFetchCreditTransactionsBeginAction extends IAction {}

export interface IFetchCreditTransactionsSuccessAction extends IAction {
  payload: {
    transactions: ICreditTransactionTableItem[];
    count: number;
    append: boolean;
  };
}

export interface IFetchCreditTransactionsFailureAction extends IAction {
  payload: { error: any };
}

export type CreditTransactionsAction =
  | IFetchCreditTransactionsBeginAction
  | IFetchCreditTransactionsSuccessAction
  | IFetchCreditTransactionsFailureAction;

/**
 * @param {Object} subcategory Can be either "map" or "list"
 * @returns {Object} Object with Type of action and the payload information from APi
 * */
export function changeSubcategorySuccessActionCreator(
  subcategory: any,
): IChangeSubcategorySuccessActionCreator {
  return {
    type: types.CHANGE_SUBCATEGORY_SELECTED_SUCCESS,
    subcategory,
  };
}
export function setCustomersLegendActionCreator(
  legend: ICustomerLegendFE,
  lang: TLang,
  legendFilterKey: string,
): ISetCustomersLegendActionCreator {
  return {
    type: types.SET_CUSTOMERS_LEGEND,
    legend,
    lang,
    legendFilterKey,
  };
}

export function clearLegendsCacheActionCreator(): IClearLegendsCacheActionCreator {
  return {
    type: types.CLEAR_LEGENDS_CACHE,
  };
}

export function setCustomersAttributeActionCreator(
  attributeTag: string,
  attributeData: TFetchCustomerAttributeServerResponseData[],
): ISetCustomerAttributeActionCreator {
  return {
    type: types.SET_CUSTOMERS_ATTRIBUTE,
    attributeTag,
    attributeData,
  };
}

export interface ISetCustomerLocationsActionCreator extends IAction {
  customerLocations: ICustomersState["customerLocations"];
  hasMoreCustomers: boolean;
  customerListSchema?: IListSchema[];
}
export function setCustomerLocationsActionCreator(
  customerLocations: ICustomersState["customerLocations"],
  hasMoreCustomers: boolean,
): ISetCustomerLocationsActionCreator {
  return {
    type: types.SET_CUSTOMER_LOCATIONS,
    customerLocations,
    hasMoreCustomers,
  };
}

export function clearCustomerData() {
  return {
    type: types.CLEAR_DATA,
  };
}

export const fetchCreditTransactionsBeginActionCreator =
  (): IFetchCreditTransactionsBeginAction => ({
    type: types.FETCH_CREDIT_TRANSACTIONS_BEGIN,
  });

export const fetchCreditTransactionsSuccessActionCreator = (
  transactions: ICreditTransactionTableItem[],
  count: number,
  append: boolean,
): IFetchCreditTransactionsSuccessAction => ({
  type: types.FETCH_CREDIT_TRANSACTIONS_SUCCESS,
  payload: { transactions, count, append },
});

export const fetchCreditTransactionsFailureActionCreator = (
  error: any,
): IFetchCreditTransactionsFailureAction => ({
  type: types.FETCH_CREDIT_TRANSACTIONS_FAILURE,
  payload: { error },
});
